/**
 * EventsIcon — A lightning bolt: what the agents reported. Hugeicons flash (MIT).
 */

import svg from './svg/events.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const EventsIcon = makeSvgIcon('events', svg);
